import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';

const GET_BUSINESS_HOURS = gql`
  query ListBusinessHoursHistories($dateRange: DateRangeInput) {
    businessHoursHistories(dateRange: $dateRange) {
      shiftDayName
      shiftDate
      histories {
        uid
        title
        startTime
        endTime
      }
    }
  }
`;

const normalizeTimeString = (val) => {
  if (!val) return '';
  const s = String(val).trim();

  const hhmm = s.match(/^(\d{1,2}):(\d{2})$/);
  if (hhmm) {
    return `${String(parseInt(hhmm[1], 10)).padStart(2, '0')}:${hhmm[2]}`;
  }

  const embedded = s.match(/(\d{2}):(\d{2})/);
  if (embedded) {
    return `${embedded[1]}:${embedded[2]}`;
  }

  return s;
};

export const useGetBusinessHours = (input) => {
  const { loading, error, data, refetch } = useQuery(GET_BUSINESS_HOURS, {
    variables: {
      dateRange: input,
    },
  });

  const normalizedData =
    data?.businessHoursHistories?.length > 0
      ? {
          ...data,
          businessHoursHistories: data.businessHoursHistories.map((d) => ({
            ...d,
            histories: (d.histories || []).map((h) => ({
              ...h,
              startTime: normalizeTimeString(h.startTime),
              endTime: normalizeTimeString(h.endTime),
            })),
          })),
        }
      : data;

  if (normalizedData) {
    console.log(
      'DEBUG: businessHoursHistories response:',
      JSON.stringify(normalizedData, null, 2)
    );
  }

  return { loading, error, data: normalizedData, refetch };
};
